import { logger } from '@/lib/logger';

export const logFPTIForANSInterstitial = (status: string): void => {
  logger.fpti(`address_normalization_interstitial_${status}`, {
    state_name: 'address_normalization',
    transition_name: `process_address_normalization_interstitial_${status}`,
  });
};

export const logFPTIForANSApi = (status: string, payLoad = {}): void => {
  logger.fpti('address_normalization_api', {
    state_name: 'address_normalization',
    transition_name: `${status}_address_normalization_api`,
    ...payLoad,
  });
};
